const NAVIGATION_ELEMENT = {
    container: 'page-nav',
    link: '.js-nav-link',
    activeClass: 'is-active',
};

/**
 * утсановки отступов у контейнера навигации
 * @param links {NodeList} - ссылки в навигации
 * @param container {HTMLElement} - контейнер навигации
 */

function setMarginToPageNavigation(links, container) {
    if (window.innerWidth >= 768) {
        let actualWidth = 0;
        links.forEach((el) => {
            const marginRight = parseInt(getComputedStyle(el).marginRight, 10);
            actualWidth += el.offsetWidth + marginRight;
        });

        if (actualWidth > container.offsetWidth) {
            const result = window.innerWidth - container.offsetWidth;
            const margins = Math.round(result / 2);
            container.setAttribute(
                'style',
                `margin-left: -${margins}px; margin-right: -${margins}px;padding-left: ${margins}px;padding-right: ${margins}px;`
            );
        }
    }
}

export default function scrollPageNavigation() {
    const container = document.getElementById(NAVIGATION_ELEMENT.container);
    if (!container || window.innerWidth > 1200) {
        return false;
    }

    const links = container.querySelectorAll(NAVIGATION_ELEMENT.link);

    setMarginToPageNavigation(links, container);

    links.forEach((el) => {
        if (el.classList.contains(NAVIGATION_ELEMENT.activeClass)) {
            const elWidth = el.offsetWidth;
            const elScrollLeft = el.offsetLeft;
            let paddingScroll = 16;
            if (window.innerWidth >= 768) { paddingScroll = 32; }
            if (container.offsetWidth < elWidth + elScrollLeft) {
                container.scrollLeft = elScrollLeft - paddingScroll;
            }
        }
    });
}
